import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { mfaVerifyTotp } from 'config/axiosInstance';
import CodeField from './CodeField';
import { ErrorBox, MfaFrame, MfaStepProps, SubmitButton, useAttempt, useStepFailure } from './MfaFrame';

/** 認証アプリの6桁のコード（mfa が totp_required）。合えばログインを終える。 */
const TotpStep: React.FC<MfaStepProps> = ({ challenge, onRestart, onSignedIn }) => {
  const { t } = useTranslation('login');
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);
  const failure = useStepFailure(onRestart);
  const beginAttempt = useAttempt();

  const submit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!/^\d{6}$/.test(code)) {
      failure.setText(t('mfa.error-code-format'));
      return;
    }
    setBusy(true);
    failure.setText('');
    const signal = beginAttempt();
    try {
      const outcome = await mfaVerifyTotp(challenge.token, code, { signal });
      if (!signal.aborted) onSignedIn(outcome);
    } catch (error) {
      if (signal.aborted) return; // やめた試行の失敗は、今の画面に当てない
      failure.handle(error);
      setBusy(false);
    }
  };

  const errorId = failure.text ? 'mfa-totp-error' : undefined;
  return (
    <MfaFrame
      title={t('mfa.totp-title')}
      subtitle={t('mfa.totp-subtitle')}
      onBack={() => onRestart(null)}
      backDisabled={busy}
    >
      <form onSubmit={submit} className="flex flex-col gap-6" noValidate>
        <CodeField
          id="mfa-totp-code"
          value={code}
          errorId={errorId}
          onChange={(value) => {
            setCode(value);
            failure.setText('');
          }}
        />
        <ErrorBox id="mfa-totp-error" text={failure.text} />
        <SubmitButton busy={busy} disabled={failure.waiting} label={t('mfa.totp-button')} />
      </form>
    </MfaFrame>
  );
};

export default TotpStep;
